// ティザーの選手リンク行のスクロール演出。
// Mobile (< 640px) は IntersectionObserver で表示中の最初の要素に .is-active を付ける。
// Desktop (>= 640px) は JS は何もせず、CSS の :hover に任せる。

function initHoverList() {
  const items = document.querySelectorAll(".hover-list-item");
  if (items.length === 0) return;

  const visibility = new Map();

  const observer = new IntersectionObserver((entries) => {
    if (window.innerWidth > 640) {
      items.forEach((el) => el.classList.remove("is-active"));
      return;
    }

    entries.forEach((entry) => {
      visibility.set(entry.target, entry.isIntersecting);
    });

    const visible = Array.from(visibility.entries())
      .filter(([, isVisible]) => isVisible)
      .map(([el]) => el);

    items.forEach((el) => el.classList.remove("is-active"));

    if (visible.length > 0) {
      const first = Array.from(items).find((el) => visible.includes(el));
      if (first) first.classList.add("is-active");
    }
  }, {
    root: null,
    rootMargin: "-290px 0px -45% 0px",
    threshold: 0,
  });

  items.forEach((el) => observer.observe(el));
}

// "トップに戻る" ボタンのスクロール表示制御。
// scrollY > 300px で .is-visible を付け、CSS の transition で fade in/out。
// クリックで smooth scroll to top。

function initScrollToTop() {
  const button = document.getElementById("scroll-to-top");
  if (!button) return;

  const showThreshold = 300;

  function updateVisibility() {
    if (window.scrollY > showThreshold) {
      button.classList.add("is-visible");
    } else {
      button.classList.remove("is-visible");
    }
  }

  window.addEventListener("scroll", updateVisibility, { passive: true });
  updateVisibility();

  button.addEventListener("click", () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
}

function initAll() {
  initHoverList();
  initScrollToTop();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAll);
} else {
  initAll();
}
